var hostname = window.location.hostname;
var DEBUG = true;
if (hostname && hostname.indexOf("swoop.de") > -1) {
    var DEBUG = false;
}
if (!DEBUG) {
    if (!window.console)
        window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function () {
        };
    }
}

/*
 function GMinitialize() {
 var mapOptions = {
 zoom: 8,
 center: new google.maps.LatLng(52.54831, 13.24964)
 };

 var map = new google.maps.Map(document.getElementById('map-canvas-menu'),
 mapOptions);
 }

 function loadGMScript() {
 var script = document.createElement('script');
 script.type = 'text/javascript';
 script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp' +
 '&signed_in=true&callback=GMinitialize';
 document.body.appendChild(script);
 }
 */

function jsonScroll(json){
    $('html, body').animate({
        scrollTop: $(json[0]['data_value_ref']).offset().top
    }, 2000);
}


function loadToolbar() {
    var elem = $('#naviStaticPage');
    if (elem) {
        var callback = $('#naviStaticPage').attr("data-url");
        var profil = $('#naviStaticPage').attr("data-profil");
        var queryString = "queryString=" + $('#naviStaticPage').attr("data-lang") + "_" + profil;
        //window.console.log("callback Page Profil="+callback);
        window.console.log("elem Page="+queryString);

        $.post(callback, queryString, function (data) {
            elem.html(data);
            elem.slideToggle(800, function () {
                $('html, body').animate({scrollTop: ($(elem).offset().top)}, '800');
                $("#naviStaticPage").data("top", $("#top-navbar").height()); // set original position on load
                $(window).scroll(fixDiv);
            });
        });
    }
}

function loadMainNav() {
    var elem = $('#main_navbar');
    if (elem) {
        var json = JSON.parse(elem.attr("data-json"));
        var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
        var queryString = 'queryString=' + jsonStr;
        //$('#pleaseWait').css({'display': 'block'}).center();
        $.post(json[0]['data_url'], queryString, function (data) {
            //ersetze den Inhalt mit dem id attribut
            if (json[0]['data_html']) {
                //window.console.log("data_html");
                $(json[0]['data_html']).html(data);
                $(json[0]['data_html']).show();
                /**
                 * ausgrauen ? folien slide ?
                 */
                loadVideo();
                loadComment();
            }
           // $('#pleaseWait').css({'display': 'none'});
        });
    }
}



function loadVideo() {
    window.console.log("loadVideo!");
    var elem = $('#nav-menu-video-wrapper');
    if (elem) {
        var json = JSON.parse(elem.attr("data-json"));
        var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
        var queryString = 'queryString=' + jsonStr;
        $('#pleaseWait').css({'display': 'block'}).center();
        $.post(json[0]['data_url'], queryString, function (data) {
            //ersetze den Inhalt mit dem id attribut
            if (json[0]['data_html']) {
                //window.console.log("data_html");
                $(json[0]['data_html']).html(data);
                $(json[0]['data_html']).show();
                /**
                 * ausgrauen ? folien slide ?
                 */
            }
            $('#pleaseWait').css({'display': 'none'});
        });
    }
}


function loadSearchBar(){
    var e=$("#mySearchBar").attr("data-url");
    var d=$("#mySearchBar").attr("data-lang");
    var b=$("#mySearchBar").attr("data-post-url");
    var c=$("#mySearchBar");var a=$("#loadProfils");
    window.console.log("callback="+e);window.console.log("loadProfils="+a);
    window.console.log("win.height="+ $(window).height());

    c.css('height',$(window).height());
    $("#mySearchBar .search-place").css('height', $(window).height());

    $.post(e,d,function(f){
        c.html(f);
        c.slideToggle(2100,function(){ //slider von oben nach unten
            $.post(b,d,function(g){$("#loadProfils").html(g)});

            if($(window).width()>=1200) {
                $("#searchform, .searchResultTotal").animate({
                    top: "+=100",
                }, 1500, function () {
                    // Animation complete.
                    window.console.log("animate complete=");
                    //button einblenden
                    //btnSwoop
                });
            }
        });
    });
}

function loadComment() {
    /*
    var callback = $('#mySearchBar').attr("data-url");
    var queryString = $('#mySearchBar').attr("data-lang");
    var callback2 = $('#mySearchBar').attr("data-post-url");
    var elem = $('#mySearchBar');
    var loadProfils = $('#menu-load-profils');
    */

    var elem = $('#menu-load-profils');
    if(elem) {
        window.console.log("loadComment=");
        var json = JSON.parse(elem.attr("data-json"));
        var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
        var queryString = 'queryString=' + jsonStr;

        $.post(json[0]['data_url'], queryString, function (data) {
            //ersetze den Inhalt mit dem id attribut
            if (json[0]['data_html']) {
                //window.console.log("data_html");
                $(json[0]['data_html']).html(data);
            }
            $('#pleaseWait').css({'display': 'none'});
        });
    }
}


function jsonFormClick(json) {

    var form = $("form_main_menu");
    if (form.validate({
            rules: {
                inputName: {required: true,},
                inputEmail: {required: true,},
                inputSubject: {required: true},
                inputMessage: {required: true},
            },
        })) {
        window.console.log("form validate()");
    } else {
        window.console.log("form NOT validate()");
        return;
    }


    len = json[0]['data_form_id'].length; //alle id zu inputfledern textfeldern usw.
    var index, len;
    index = 0;

    for (; index < len; index++) {
        var real_id = json[0]['data_form_id'][index];
        //window.console.log($(real_id).attr('type'));
        window.console.log($(real_id).prop("tagName"));

    }

    $('#pleaseWait').css({'display': 'block'}).center();

    var jsonStr = JSON.stringify(json);
    var queryString = 'queryString=' + jsonStr;
    $.post(json[0]['data_url'], queryString, function (data) {
        //ersetze den Inhalt mit dem id attribut
        if (json[0]['data_html']) {
            //window.console.log("data_html");
            $(json[0]['data_html']).html(data);
            $(json[0]['data_html']).show();
            /**
             * ausgrauen ? folien slide ?
             */

            $('#pleaseWait').css({'display': 'none'});
        }
    });
}


function jsonClick(json) {
    window.console.log("in funtion jsonClick");
    //test if array()
    if (json[0]['data_value_ref']) {
        if (Object.prototype.toString.call(json[0]['data_value_ref']) === '[object Array]') {
            window.console.log("l1");
            var index, len;
            index = 0;
            len = json[0]['data_value_ref'].length;
            window.console.log("l2");

            json[0]['data_value'] = [];
            for (; index < len; index++) {
                window.console.log("l3");
                //window.console.log("value="+ json[0]['data_value_ref'][index]);
                if ($(json[0]['data_value_ref'][index])) {

                    json[0]['data_value'][index] = $(json[0]['data_value_ref'][index]).val();
                    window.console.log("value=" + json[0]['data_value'][index]);
                }
            }
        }
        else {
            json[0]['data_value'] = $(json[0]['data_value_ref']).val();
        }
    }
    var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
    var queryString = 'queryString=' + jsonStr;
    $('#pleaseWait').css({'display': 'block'}).center();

    $.post(json[0]['data_url'], queryString, function (data) {
        //ersetze den Inhalt mit dem id attribut
        if (json[0]['data_html']) {
            //window.console.log("data_html");
            $(json[0]['data_html']).html(data);
            $(json[0]['data_html']).show();
            /**
             * ausgrauen ? folien slide ?
             */
        }
        //füge den inhalt an ein id attribut
        else if (json[0]['data_append']) {
            $(json[0]['data_append']).append(data);
        }
        //gehe rückwärts um data_depth_replace schritte und wechsel den inhalt aus
        else if (json[0]['data_depth_replace']) {
            var depth = 1;
            var elem = $(this);
            depth = json[0]['data_depth_replace'];
            while (depth > 0) {
                elem = elem.parent();
                depth--;
            }
            elem.html(data);
        }

        $('#pleaseWait').css({'display': 'none'});
    });
}


function jsonClickMC(json, indexCurrent) {

    var index, len;
    index = indexCurrent;
    len = json.length;

    window.console.log("in funtion jsonClickMC");
    window.console.log("index==" + index);
    if (json[index]['data_value_ref']) {
        json[index]['data_value'] = $(json[index]['data_value_ref']).val();
    }
    var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
    var queryString = 'queryString=' + jsonStr;
    $('#pleaseWait').css({'display': 'block'}).center();

    $.post(json[index]['data_url'], queryString, function (data) {
        //ersetze den Inhalt mit dem id attribut
        if (json[index]['data_html']) {
            window.console.log("data_html");
            $(json[index]['data_html']).html(data);
            $(json[index]['data_html']).show();
            /**
             * ausgrauen ? folien slide ?
             */
        }
        //füge den inhalt an ein id attribut
        else if (json[index]['data_append']) {
            $(json[index]['data_append']).append(data);
        }
        //gehe rückwärts um data_depth_replace schritte und wechsel den inhalt aus
        else if (json[index]['data_depth_replace']) {
            var depth = 1;
            var elem = $(this);
            depth = json[index]['data_depth_replace'];
            while (depth > 0) {
                elem = elem.parent();
                depth--;
            }
            elem.html(data);
        } else if (json[index]['data_callback_fn']) {
            //todo 
            //eigene callbackfunktion einbauen für weitere animationen usw.
            var fn = window[json[index]['data_callback_fn']];
            if (typeof fn === 'function') {
                fn(json);
            }
        }

        if (index < len - 1) {
            jsonClickMC(json, index + 1);
        }
    });

    $('#pleaseWait').css({'display': 'none'});
}

function MCTest(json) {
    window.console.log("in funtion MCTest");
}

function fixDiv() {
    var $div = $("#naviStaticPage");
    if ($(window).scrollTop() > $div.data("top")) {
        //$('#naviPage').css({'position': 'fixed', 'top': '0', 'width': '100%' }); 
        $('#naviStaticPage').addClass('navbar-fixed-top');
        $('#naviStaticPage .alert-white').css({'background-color': 'rgba(255, 255, 255, 1)'});
    }
    else {
        $('#naviStaticPage').removeClass('navbar-fixed-top'); //css({'position': 'static', 'top': 'auto', 'width': '100%'});
        $('#naviStaticPage .alert-white').css({'background-color': 'rgba(255, 255, 255, 0.6)'});
    }
}


$(function () {
    $(window).ready(function () { //ready --> load für async
        window.console.log("initAsyncLoad=");
        initAsyncLoad();
    });
    $(window).load(function () { //ready --> load für async
        window.console.log("initAsyncLoad=");
        loadSearchBar();
    });
});


function initAsyncLoad() {
    window.console.log("initAsyncLoad");
    loadMainNav(); //loadComment(); loadVideo();
    loadToolbar();
    loadScripts();
    $.cookieBar({
        fixed: true,
        bottom: true,
        message: 'Cookies optimieren die Bereitstellung unserer Dienste. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden.',
        policyURL: window.location.href + 'cookies.html',
        policyText: 'Nutzungsbedingungen',
        policyButton: true,
        acceptText: 'Ich akzeptiere',
        declineButton: true, //Set to true to show decline/disable button
        declineText: 'Cookies Deaktivieren', //Text on decline/disable button
        append: true,
        acceptFunction: function(cookieValue){
            if(cookieValue!='enabled' && cookieValue!='accepted') window.location = window.location.href;
            //IP noch speichern!!
        },
    });
}


function changeMenu() {
    var isTop500 = false;
    /*
     window.console.log("changeMenu=" + $(window).scrollTop());

     if ($(window).scrollTop() > 500) {
     //if(!isTop500){
     $('#a1').addClass('a1color');
     //  isTop500 = true;
     //}
     }
     if ($(window).scrollTop() > 700) {
     //if(!isTop500){
     $('#a2').addClass('a2color');
     //  isTop500 = true;
     //}
     }
     if ($(window).scrollTop() > 900) {
     //if(!isTop500){
     $('#a3').addClass('a3color');
     //  isTop500 = true;
     //}
     }
     if ($(window).scrollTop() > 1100) {
     //if(!isTop500){
     $('#a4').addClass('a4color');
     //  isTop500 = true;
     //}
     }

     if ($(window).scrollTop() < 1100) {
     $('#a4').removeClass('a4color');
     }

     if ($(window).scrollTop() < 900) {
     $('#a3').removeClass('a3color');
     }

     if ($(window).scrollTop() < 700) {
     $('#a2').removeClass('a2color');
     }

     if ($(window).scrollTop() < 500) {
     $('#a1').removeClass('a1color');
     }
     */

}


function loadScripts() {

    /*
     $('.search-place').parallax("50%", 0.1);
     $('.search-place-inner').parallax("50%", 0.4);
     $('#searchform').parallax("70%", 0.2);
     */
    window.console.log("loadScripts()");

    /*
    $("#flip1").flip({
        axis: 'y',
        trigger: 'click'
    });*/

    $('a.scroll').on('click', function (e) {
        var href = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(href).offset().top
        }, 'slow');
        e.preventDefault();
    });

    /**
     * Ein link wird gedrückt!
     */
    $(document).on('click', '.jsonClick', function (e) {
        e.preventDefault();
        window.console.log("jsonClick=");
        var json = JSON.parse($(this).attr("data-json"));
        jsonClick(json);
    });

    $(document).on('click', '.jsonScroll', function (e) {
        e.preventDefault();
        window.console.log("jsonScroll=");
        var json = JSON.parse($(this).attr("data-json"));
        jsonScroll(json);
    });

    $(document).on('click', '.jsonClick_MC', function (e) {
        e.preventDefault();
        window.console.log("jsonClickMC=");
        var json = JSON.parse($(this).attr("data-json"));
        jsonClickMC(json, 0);
    });

    $(document).on('click', '.jsonFormClick', function (e) {
        e.preventDefault();
        window.console.log("jsonFormClick=");
        var json = JSON.parse($(this).attr("data-json"));
        jsonFormClick(json);
    });


    $(document).on('click', '.gm', function (e) {
        e.preventDefault();
        window.console.log("gm=");
        GMinitialize();
    });


    /**
     * ergebnis Tags Ansicht, daraus wurde ein Link gedrückt
     */
    $(document).on('click', '.contentEntrySmall', function (e) {
        window.console.log("contentEntrySmall=");
        var a = $(this).children();
        if ($(a).attr("data-json")) {
            e.preventDefault();
            var json = JSON.parse($(a).attr("data-json"));
            jsonClick(json);
        } else {
            window.location.href = $(a).attr('href');
        }
    });
    /**
     * Go Button gedrückt
     */
    $(document).on('click', '#searchbtn', function (e) {
        e.preventDefault();
        window.console.log("searchbtn=");

        var json = JSON.parse($('#inputString').attr("data-json"));
        json[0]['data_value'] = $('#inputString').val();
        json[0]['filter_pre_and_post'] = true;
        if ($("#inputString").val().length > 2) {
            jsonClick(json);
        }
    });

    /**
     * Suche
     * init_b2b, init_suche, init_branche
     */
    $(document).on('keyup', '#inputString', function (e) {
        window.console.log("#inputString.change");

        var json = JSON.parse($(this).attr("data-json"));
        json[0]['data_value'] = $(this).val();
        var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
        var queryString = 'queryString=' + jsonStr;

        if ($(this).val().length <= 2) {
            $('.menu-switch-comment-btn').css('z-index', 50);
            $('.menu-switch-video-btn').css('z-index', 50);
            $(json[0]['data_html']).fadeOut(); // Hide the suggestions box
            window.console.log("=<2");
        } else {
            window.console.log(">2");
            var idx = json[0]['data_value'].indexOf('.');
            var arrayOfStrings = json[0]['data_value'].split('.');
            //alert(arrayOfStrings.length);
            //if (arrayOfStrings.length == 1) { //b2b/ajaxSearch
            window.console.log("arrayOfStrings.length == 1");
            $.post(json[0]['data_url'], queryString, function (data) {
                if (json[0]['data_html']) {
                    $(json[0]['data_html_2']).fadeOut();
                    $(json[0]['data_html']).fadeIn();
                    $(json[0]['data_html']).html(data);
                    $(json[0]['data_html']).show(); //#suggestions
                }
            });

            /*
             else if (arrayOfStrings.length == 2) {  //b2b/ajaxSearchState
             window.console.log("arrayOfStrings.length == 2");
             $.post(json[0]['data_url_2'], queryString, function (data) {
             $(json[0]['data_html']).fadeOut();
             $('.menu-switch-comment-btn').css('z-index', 1);
             $('.menu-switch-video-btn').css('z-index', 1);
             $(json[0]['data_html_2']).fadeIn();
             $(json[0]['data_html_2']).html(data);
             $(json[0]['data_html_2']).show(); //#suggestionsCountryState
             });
             }*/
        }
    });


    $("body").keypress(function (e) {
        if (e.which == 13) { //enter
            e.preventDefault();
            window.console.log("enter gedrückt");
            if($('#inputString')) {
                var json = JSON.parse($('#inputString').attr("data-json"));
                json[0]['data_value'] = $('#inputString').val();
                json[0]['filter_pre_and_post'] = true;
                if ($("#inputString").val().length > 2) {
                    jsonClick(json);
                }
            }
            /*
             var pathname = $('head base').attr('href')+"suche/";
             var queryString = $("#inputString").val().toLowerCase();
             var firstChar = $("#inputString").val().substring(0,1).toUpperCase()+"/";
             if($("#inputString").val().length>0){
             window.location =  pathname+firstChar+queryString+".html";
             }*/
        }
    });


    /**
     * Wird bei einer Änderung bei input oder select ausgelöst
     */
    $(document).on('change', '.jsonChange', function (e) {
        var json = JSON.parse($(this).attr("data-json"));
        json[0]['data_value'] = $(this).val();

        var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet
        var queryString = 'queryString=' + jsonStr;
        $('#pleaseWait').css({'display': 'block'}).center();
        $.post(json[0]['data_url'], queryString, function (data) {
            if (json[0]['data_html']) {
                window.console.log("json html=" + json[0]['data_html']);
                $(json[0]['data_html']).html(data);
                $(json[0]['data_html']).show();
                /**
                 * ausgrauen ? folien slide ?
                 */
            } else if (json[0]['data_append']) {
                $(json[0]['data_append']).append(data);
            }

            $('#pleaseWait').css({'display': 'none'});
        });
    });

    /*
     $(document).on('click', '.toggleNavMenu', function (e) {
     e.preventDefault();
     var target = $(this).attr("data-target");
     var close = $(this).attr("data-close");
     window.console.log("target=" + target);
     window.console.log("close=" + close);

     if (close == '#fullNavMenu') {
     $(close).toggle('slide', {direction: 'right'}, 600, function () {
     $(target).toggle('slide', {direction: 'right'}, 300);
     });
     } else {
     $(close).toggle('slide', {direction: 'right'}, 300, function () {
     $(target).toggle('slide', {direction: 'right'}, 600);
     });
     }
     });*/


    $(window).scroll(changeMenu);

    $(document).on('mouseenter', '.mouseover', function (e) {
        var atr = $(this).attr("data-mouseover");
        window.console.log(atr);
        if (atr) {
            $(atr).slideToggle("slow", function () {
            });
        }
    });

    $(document).on('mouseleave', '.mouseover', function (e) {
        var atr = $(this).attr("data-mouseover");
        window.console.log(atr);
        if (atr) {
            $(atr).slideToggle("slow", function () {
            });
        }
    });

    //Modal Dialog 
    $(document).on('click', '.jsonViewModal', function (e) {
        e.preventDefault();
        var json = JSON.parse($(this).attr("data-json"));

        var atr = json[0]['data_modal_target'];
        var main = $(atr).find(".modal-body");
        main.html(json[0]['data_modal_content']);
        var title = $(atr).find(".modal-header .modal-title");
        title.text(json[0]['data_modal_title']);

        var okButton = $(atr).find(".onOkModal");
        if (okButton) {
            if (json[0]['data_modal_ok_label']) {
                window.console.log("json data_modal_ok_label found");
                if (okButton) {
                    window.console.log("okButton found");
                    okButton.text(json[0]['data_modal_ok_label']);
                }
                else {
                    window.console.log("okButton not found");
                }
            }
            if (json[0]['data_modal_ok_button_disable']) {
                var okButton = $(atr).find(".onOkModal");
                okButton.hide();
            } else {
                okButton.show();
            }
        } else {
            window.console.log("class onOkModal not found");
        }
        if (json[0]['data_url']) {
            main.html('<img src="/firmen/swoop/application/media/img/sw/icon_loading.gif" data-original-title="" title="">');
            var jsonStr = JSON.stringify(json); //es wird zu stdClass gecastet

            $.post(json[0]['data_url'], 'queryString=' + jsonStr, function (data) {
                //video template anzeihen in main!
                main.html(data);
            });
        }
        $(atr).data("data-current", $(this));
        //zuordnen von Inhalten für modal dialog
        $(atr).modal('show');
    });

    $('.mypopover')
        .on('click', '.mypopover', function (e) {
            window.console.log('mytooltip=popover');
            e.preventDefault();
        })
        .popover({
            offset: 10,
            trigger: 'hover',
            animate: false,
            html: true,
            placement: 'bottom'
        });

    $('.progress .progress-bar').progressbar({
        transition_delay: 1500,
        refresh_speed: 50,
        display_text: 'none'
    });

    $('#reanimate1').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate1',
        next_check_y: 50
    });

    $('#reanimate2').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate2',
        next_check_y: 50
    });

    $('#reanimate3').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate3',
        next_check_y: 50
    });

    $('#reanimate4').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate4',
        next_check_y: 50
    });
    $('#reanimate5').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate5',
        next_check_y: 50
    });
    $('#6reanimate').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate6',
        next_check_y: 50
    });
    $('#reanimate7').reanimate({
        offset_y: -200,
        idNameTrigger: '#reanimate7',
        next_check_y: 50
    });
    $('#reanimate8').reanimate({
        offset_y: -10,
        idNameTrigger: '#reanimate8',
        next_check_y: 50
    });
}

//window.onload = loadGMScript;
